module.exports = __webpack_public_path__ + "media/top.b615b490.mp4";